//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'CanadianCSpine',
  data() {
    return {
      form:{
        inc_trauma:'0',
        inc_age:'0',
        inc_vitals:'0',
        inc_gcs:'0',

        exc_paralysis:'0',
        exc_vertebra:'0',
        exc_surgery:'0',



        hr_age:'0',
        hr_mechanism:'',
        hr_parestesia:'0',

        lr_mvc:'',
        lr_sitting:'0',
        lr_ambulatory:'0',
        lr_delayed:'0',
        lr_tenderness:'0',

        motion_good:'0'

      },
      hasScore:false,
      disabled:false,
      defaultJson:{
        "Meaning not immediate onset of neck pain":'非立刻出现的颈部疼痛',
        "5. Assessment of Range of Motion": "5. 活动范围评估",
        "Fall from ≥ 1 m \/ 5 stairs": "从 ≥ 1 m 或 5 级台阶高度跌落",
        "MVC high speed (>100km\/hr), rollover, ejection": "机动车高速撞击（> 100 km\/h），翻滚，弹射",
        "Radiography recommended": "建议进行影像学检查",
        "Previous C-Spine Surgery": "既往颈椎手术史",
        "Age ≥ 16 years": "年龄 ≥ 16 岁",
        "No Radiography": "无需影像学检查",
        "Hit by bus \/ large truck": "公交车\/大型卡车撞击",
        "Glasgow Coma Scale = 15": "Glasgow 昏迷评分 = 15",
        "Known Vertebral Disease": "已知的椎体疾病",
        "Dangerous Mechanism": "危险机制",
        "Pushed into oncoming traffic": "被推入驶来的车流中",
        "Ambulatory at Any Time": "可任意走动",
        "Stable Vital Signs": "生命体征平稳",
        "Bicycle struck or collision": "自行车撞击",
        "Acute Paralysis": "急性瘫痪",
        "Axial load to head, e.g. diving": "头部的轴向撞击，如跳水",
        "Age ≥ 65 years": "年龄 ≥ 65 岁",
        "Motorized recreational vehicles": "机动休旅车撞击",
        "3. Any High-Risk Factors Which Mandates Radiography?": "3. 存在必须接收影像学检查的高危因素？",
        "1. Inclusion Factors": "1. 必要因素",
        "Simple Rearend MVC": "单纯机动车追尾",
        "Absence of Midline C-Spine Tenderness": "无颈中线压痛",
        "Choose a Mechanism": "选择一种情况",
        "Able to Actively Rotate Neck 45° Left and Right": "能够自主向左右两侧转动颈部达 45°",
        "Sitting Position in ED": "急诊室中可维持坐位",
        "YES": "是",
        "Rollover": "翻滚",
        "The rule does not apply": "该规则不适用",
        "Delayed Onset of Neck Pain": "迟发性颈部疼痛",
        "Hit by high speed vehicle": "机动车高速撞击",
        "Trauma": "创伤",
        "None of the above": "以上均不符合",
        "NO": "否",
        "2. Exclusion Factors": "2. 排除因素",
        "4. Any Low-Risk Factors Which Allows Safe Assessment of Range of Motion?": "4. 存在任何足以安全评估活动范围的低危因素？",
        "Paresthesias in Extremities": "肢端感觉异常"
      },
      do_include:0,
      no_exclude:0,
      any_high_risk:0,
      any_low_risk:0,
      dataList1:[
        {value:"1",name:'从 ≥ 1 m 或 5 级台阶高度跌落',shortName:'是',},
        {value:"2",name:'头部的轴向撞击，如跳水',shortName:'是'},
        {value:"3",name:'机动车高速撞击（> 100 km/h），翻滚，弹射',shortName:'是'},
        {value:"4",name:'机动休旅车撞击',shortName:'是'},
        {value:"5",name:'自行车撞击',shortName:'是'},
        {value:"0",name:'以上均不符合',shortName:'否'},
      ],
      dataList2:[
        {value:"0",name:'被推入驶来的车流中',shortName:'否'},
        {value:"-1",name:'公交车/大型卡车撞击',shortName:'否'},
        {value:"-2",name:'翻滚',shortName:'否'},
        {value:"-3",name:'机动车高速撞击',shortName:'否'},
        {value:"1",name:'以上均不符合',shortName:'是'},
        {value:"-4",name:'N/A',shortName:'非车祸'},
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
            form[key]=0
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      // (inc_trauma + inc_age + inc_vitals + inc_gcs) == 4
      let currentInclude = form.inc_trauma + form.inc_age + form.inc_vitals + form.inc_gcs
      self.do_include = currentInclude==4 ? 1 : 0

      // 	(exc_paralysis + exc_vertebra + exc_surgery) == 0
      let currentNo_exclude = form.exc_paralysis + form.exc_vertebra + form.exc_surgery
      self.no_exclude = currentNo_exclude==0 ? 1 : 0

      // 	hr_age ? 1 : (hr_parestesia ? 1 : hr_mechanism)
      form.hr_mechanism = form.hr_mechanism > 1 ? 1 : form.hr_mechanism
      console.log(`form.hr_mechanism:${form.hr_mechanism}`);
      self.any_high_risk = form.hr_age ? 1 : (form.hr_parestesia ? 1 : form.hr_mechanism)
      console.log(`form.any_high_risk:${self.any_high_risk}`);

      // 	(lr_sitting + lr_ambulatory + lr_delayed + lr_tenderness &gt; 0) ? 1 : lr_mvc
      form.lr_mvc = form.lr_mvc<0?0:form.lr_mvc
      self.any_low_risk = (form.lr_sitting + form.lr_ambulatory + form.lr_delayed + form.lr_tenderness) > 0 ? 1 : form.lr_mvc


      // do_include ? (no_exclude ? (any_high_risk ? 1:((hr_mechanism == 0) ?(any_low_risk ?(motion_good ? 2 : 1):1):null)):0):0


      let result = self.do_include ? (self.no_exclude ? (self.any_high_risk ? 1:((form.hr_mechanism == 0) ?(self.any_low_risk ?(form.motion_good ? 2 : 1):1):null)):0):0
      self.hasScore = true
      return String(result)
    },
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/CanadianCSpine.vue